import { ColumnDef } from '@tanstack/react-table'
import { DataTableColumnHeader } from '@/components/shared/data-table/data-table-column-header'
import { Button } from '@/components/ui/button'
import { useNavigate } from 'react-router-dom'

export const columns: ColumnDef<any>[] = [
  {
    accessorKey: 'container_id',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Container ID" />
    ),
    cell: ({ row }) => <div>{row.getValue('container_id')}</div>,
  },
  {
    accessorKey: 'advanced_product_id',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Advanced Product ID" />
    ),
    cell: ({ row }) => <div>{row.getValue('advanced_product_id')}</div>,
  },
  {
    accessorKey: 'name',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Name" />
    ),
    cell: ({ row }) => <div>{row.getValue('name')}</div>,
  },

  // {
  //   id: "actions",
  //   cell: ({ row }) => {
  //     const navigate = useNavigate();
  //     return (
  //       <Button
  //         variant="outline"
  //         size="sm"
  //         onClick={() =>
  //           navigate(
  //             `/dashboard/b2b-accounts/price-lists/${row.getValue("id")}`
  //           )
  //         }
  //       >
  //         View Details
  //       </Button>
  //     );
  //   },
  // },
]
